<svelte:options accessors />

<script lang="ts">
  import { fade } from 'svelte/transition';

  export let isShow = false;
  export let text = '';
  export let duration = 2000;

  export const clear = () => {
    isShow = false;
  };

  export const resolveShow = () => {
    if (duration > 0 && isShow) {
      setTimeout(() => {
        isShow = false;
      }, duration);
    }
  };
</script>

<div>
  {#if isShow}
    <div in:fade={{ duration: 500 }} out:fade={{ duration: 300 }} class="toast-wrapper">
      {text}
    </div>
  {/if}
</div>

<style lang="scss">
  .toast-wrapper {
    position: fixed;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
    max-width: 250px;
    // 提高toast的z-index
    z-index: 3005;
    border-radius: 8px;
    color: #ffffff;
    padding: 14px 16px 13px 16px;
    text-align: center;
    font-size: 14px;
    line-height: 21px;
    font-family: PingFangSC-Regular;
    font-weight: 500;
    background-color: rgba(0, 0, 0, 0.85);
    opacity: 1;
  }
</style>
